import { render } from "./product-form-drawer.vue?vue&type=template&id=4083a624"
import script from "./product-form-drawer.vue?vue&type=script&lang=js"
export * from "./product-form-drawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__